module.exports = __webpack_public_path__ + "img/cover_letter.146e51c1.svg";